



// Import Swiper React components

// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/pagination";
import "swiper/css/navigation";

// import required modules
import BarcelonaSplashPage from "./BarcelonaSplash";









export default function BarcelonaSplashBlogPage({
}) {
  return (
      <BarcelonaSplashPage></BarcelonaSplashPage>
  );
}


